import { httpClient } from "lib/axios";

export const report_api = {
  get_cutoff: async date => {
    return await httpClient
      .get(`/cut_off/?date=${date}`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  acknowledge_cutoff: async payload => {
    return await httpClient
      .post(`/cut_off/`, payload)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  get_delivery_report: async date => {
    return await httpClient
      .get(`/delivery_report/`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },

get_notify_report: async (params) => {
  const url = params ? `/notify_report/?${params}` : `/notify_report/`;
  return await httpClient
    .get(url)
    .then(res => res.data)
    .catch(err => {
      return { success: false, message: err.message || "Error fetching", data: [], count: 0 };
    });
},

  get_delivery_status: async mobile_no => {
    return await httpClient
      .get(`/notify-delivery-status/?mobile_no=${mobile_no}`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },

 get_order_status: async (payload) => {
  return await httpClient
    .post(`/order_status_report/`, payload)
    .then(res => res.data)
    .catch(err => ({
      success: false,
      message: err.message,
      data: [],
      count: 0
    }));
},


};

